// extracted by mini-css-extract-plugin
export default {"header":"Header_header__rDvkD","main-image":"Header_main-image__e6TGP"};